import React from 'react';

const JobLimitAlert = ({ onClose, title, message }) => (
  <div>
    <div className="alert alert-dismissible fade show px-1" role="alert">
      <div className="text-left ml-2">
        <button type="button" className="close pr-1 pt-0" aria-label="Close" onClick={onClose}>
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 className="alert-heading mt-2">
          {title}
        </h4>
        <p className="my-2">
          {message}
        </p>
        <a href="/billing" className="btn btn-primary mt-2">Upgrade your Subscription</a>
      </div>
    </div>
  </div>
);

export default JobLimitAlert;
